import isEmpty from 'ramda/src/isEmpty';
import isNil from 'ramda/src/isNil';

/**
 * Checks if a value is null, undefined, or empty
 * @param value
 */
export const isNilOrEmpty = <T>(value: T): boolean =>
  isNil(value) || isEmpty(value);
